export const setMyAgentProfile = (myAgent) => ({
  type: "SET_AGENT_PROFILE",
  payload: myAgent,
});

  export const setMyAgentProfilePresences = (presencesProfile) => {
    return {
      type: "SET_MY_AGENT_PROFILE_PRESENCES",
      payload: presencesProfile, 
    };
  };